// extracted by mini-css-extract-plugin
module.exports = {"labels":"Labels_labels__1AYLQ","label":"Labels_label__3p557","labelInactive":"Labels_labelInactive__2nZQ8"};